<template>
  <div>
    <FormSearchableSelect
      v-show="!loadingError"
      :options="contactOptions"
      :value="value"
      @input="updateValue($event)"
      :placeholder="placeholder"
      :field="field"
      :note="note"
      :loading="loading"
    />
    <span class="text-danger" v-if="loadingError">{{loadingError}}</span>
  </div>
</template>

<script>
export default {
  name: 'ContactSearchableSelect',
  model: {
    event: 'input'
  },
  props: {
    value: [Number, String],
    placeholder: {
      type: String,
      default: 'Contact'
    },
    field: String,
    note: String,
    isCustomer: {
      type: Boolean,
      default: true
    },
    isSupplier: {
      type: Boolean,
      default: false
    },
    activeOnly: {
      type: Boolean,
      default: true
    },
    nullSelectionEnabled: {
      type: Boolean,
      default: false
    },
    nullSelectionName: {
      type: String,
      default: 'No Customer'
    }
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      contactLookup: []
    }
  },
  computed: {
    contactOptions() {
      var contactList = []
      if(this.nullSelectionEnabled) {
        contactList.push({ value: null, name: this.nullSelectionName })
      }
      contactList = contactList.concat(this.contactLookup)
      return contactList
    }
  },
  mounted() {
    this.loading = true
    var options = { }
    if(this.activeOnly)
      options.isActive = 1
    if(this.isCustomer)
      options.isCustomer = 1
    if(this.isSupplier)
      options.isSupplier = 1

    this.$apiService.contactService.getContactList(options)
    .then(response => {
      this.contactLookup = response.data.map(item => {
        return { value: item.id, name: item.name }
      })
    })
    .catch(err => {
      this.loadingError = 'Error accessing data'
    })
    .finally(() => {
      this.loading = false
    })
  },
  methods: {
    updateValue(id) {
      this.$emit('input', id)

      // Update with extra info for the stock details
      let contactInfo = this.contactLookup.find(contact => contact.value == id)
      if(!contactInfo) {
        this.$emit('updateContactInfo', null)
      } else {
        this.$emit('updateContactInfo', {
          id: id,
          name: contactInfo.name
        })
      }
    }
  }
}
</script>